import { Component, EventEmitter, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'app/core/services/user.service';
import { AppConstants } from 'app/app.constants';
import { ActiveView } from '../../login-page.component';

@Component({
  standalone: true,
  selector: 'app-forgot-password-form',
  templateUrl: './forgot-password-form.component.html',
  styleUrls: ['./forgot-password-form.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    TranslateModule,
  ],
})
export class ForgotPasswordFormComponent {
  @Output() changeView = new EventEmitter<ActiveView>();

  private fb = inject(FormBuilder);
  private userService = inject(UserService);
  private translate = inject(TranslateService);
  private toastr = inject(ToastrService);

  isLoading = false;
  sendSuccess = false;

  form = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
  });

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    const email = this.form.value.email;
    const lang =
      localStorage.getItem(AppConstants.KEYS_LOCAL_STORAGE.ISO_LANG) ||
      AppConstants.LANGUAGES.PT_BR;

    this.userService.forgotPassword(email, lang).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.sendSuccess = true;
        if (response?.resetLink) {
          window.location.href = response.resetLink;
          return;
        }
        this.translate.get('forgot.subtitle-mail').subscribe((res: string) => {
          this.toastr.success(res, '', {
            positionClass: 'toast-top-full-width',
          });
        });
      },
      error: () => {
        this.isLoading = false;
        this.translate
          .get('global.validate.mail-required')
          .subscribe((res: string) => {
            this.toastr.error(res, '', {
              positionClass: 'toast-top-full-width',
            });
          });
      },
    });
  }
}
